// extracted by mini-css-extract-plugin
module.exports = {"sub":"SubNav_sub__mDR5H","sub__amount":"SubNav_sub__amount__U6T90","sub__amount__txt":"SubNav_sub__amount__txt__hg__a"};